import api from "./axios";

// Item Categories
export const fetchItemCategories = async (params = {}) => {
  return api.get("/inventory/categories", { params });
};
export const fetchAllItemCategories = async () => {
  return api.get("/inventory/categories/all");
};
export const createItemCategory = async (data) => {
  return api.post("/inventory/categories", data);
};
export const updateItemCategory = async (id, data) => {
  return api.put(`/inventory/categories/${id}`, data);
};
export const deleteItemCategory = async (id) => {
  return api.delete(`/inventory/categories/${id}`);
};

// Item Master
export const fetchItems = async (params = {}) => {
  return api.get("/inventory/items", { params });
};
export const fetchAllItems = async () => {
  return api.get("/inventory/items/all");
};
export const exportItems = async (params = {}) => {
  return api.get("/inventory/items", {
    params: { ...params, export: true },
    responseType: "blob",
  });
};
export const createItem = async (data) => {
  return api.post("/inventory/items", data);
};
export const updateItem = async (id, data) => {
  return api.put(`/inventory/items/${id}`, data);
};
export const deleteItem = async (id) => {
  return api.delete(`/inventory/items/${id}`);
};

// Warehouses
export const fetchWarehouses = async (params = {}) => {
  return api.get("/inventory/warehouses", { params });
};
export const fetchAllWarehouses = async () => {
  return api.get("/inventory/warehouses/all");
};
export const createWarehouse = async (data) => {
  return api.post("/inventory/warehouses", data);
};
export const updateWarehouse = async (id, data) => {
  return api.put(`/inventory/warehouses/${id}`, data);
};
export const deleteWarehouse = async (id) => {
  return api.delete(`/inventory/warehouses/${id}`);
};

// Stock & Transactions
export const fetchStockLevels = async (params = {}) => {
  return api.get("/inventory/stock", { params });
};
export const fetchWarehouseItems = async (warehouseId) => {
  return api.get(`/inventory/warehouse/${warehouseId}/items`);
};
export const adjustStock = async (data) => {
  return api.post("/inventory/adjust-stock", data);
};
export const addInitialStock = async (data) => {
  return api.post("/inventory/initial-stock", data);
};
export const fetchTransactions = async (params = {}) => {
  return api.get("/inventory/transactions", { params });
};

// Project Inventory
export const fetchProjectItems = async (projectId) => {
  return api.get(`/projects/${projectId}/items`);
};
export const assignItemToProject = async (projectId, data) => {
  return api.post(`/projects/${projectId}/items/assign`, data);
};
export const returnItemFromProject = async (projectId, itemTransactionId, data) => {
  return api.post(
    `/projects/${projectId}/items/${itemTransactionId}/return`,
    data,
  );
};
